var neutral = {
  0: '#FFFFFF',
  1: '#F8F8F8',
  2: '#ECECEC',
  3: '#D7D7D7',
  4: '#BBBBBB',
  5: '#999999',
  6: '#747474',
  7: '#4D4D4D',
  8: '#292929',
  9: '#080808',
  10: '#000000'
};
var digiBlue = {
  1: '#F2F8FF',
  2: '#E2F0FF',
  3: '#BBDBFF',
  4: '#5499FF',
  5: '#195AFF',
  6: '#0B48E5',
  7: '#0137C1',
  8: '#09329B',
  9: '#05236F',
  10: '#051233'
};
var secondary = {
  1: '#FFF1DD',
  2: '#FFD988',
  3: '#FFB72B',
  4: '#FF8A00',
  5: '#EF5200',
  9: '#822E01'
};
var red = {
  1: '#FBD3D3',
  2: '#F9B5B5',
  3: '#F68C8D',
  4: '#F25C5D',
  5: '#ED2628',
  6: '#C51013',
  7: '#8B0B0E',
  8: '#530709',
  9: '#210304'
};
var green = {
  1: '#E4FAE2',
  2: '#D0F6C6',
  4: '#A4F86E',
  5: '#06A759',
  9: '#015C2E'
};
var blue = {
  20: '#E2F1FF',
  40: '#178DFF',
  60: '#0461BB',
  80: '#00407F'
};
var spacing = {
  0: '0px',
  4: '4px',
  8: '8px',
  12: '12px',
  16: '16px',
  20: '20px',
  24: '24px',
  28: '28px',
  32: '32px',
  40: '40px',
  48: '48px',
  64: '64px',
  80: '80px',
  96: '96px'
};
var fontSize = {
  10: '10px',
  12: '12px',
  13: '13px',
  14: '14px',
  15: '15px',
  16: '16px',
  17: '17px',
  18: '18px',
  20: '20px',
  22: '22px',
  24: '24px',
  28: '28px',
  30: '30px',
  32: '32px',
  44: '44px',
  48: '48px',
  56: '56px',
  64: '64px'
};
export default {
  neutral: neutral,
  digiBlue: digiBlue,
  secondary: secondary,
  red: red,
  green: green,
  blue: blue,
  spacing: spacing,
  fontSize: fontSize
};